import { BridgeComponent } from '@hotwired/hotwire-native-bridge'

// Hands a merchant link to the device's default browser (Safari), where the user
// has their merchant sessions and where the affiliate cookie must land.
//
// iOS only, and by the bridge's own rules: `shouldLoad` reads the components the
// User-Agent lists, and only the iOS app registers `merchant-link`. On Android —
// and on the web — this controller never loads, the <a target="_blank"> takes
// over, and the native side picks up the window it opens
// (ListyWebChromeClient + OutboundLinkRouteDecisionHandler).
//
// The URL is decided by the page, not here: in the app the `link` controller has
// already rewritten the href into its affiliate form at load time (see
// link_controller#connect, driven by data-link-native-value), so the raw href is
// what goes out only where there was nothing to rewrite — a page without
// automonetize_tag, or an Amazon product whose href is the server 302
// `/redirection`. Either way the native side opens it without inspecting it.
export default class extends BridgeComponent {
  static component = 'merchant-link'

  open(event) {
    if (!this.enabled) return

    // preventDefault ONLY: stopImmediatePropagation would silence every action
    // that follows on this same link.
    event.preventDefault()
    this.send('open', { url: this.element.href })
  }
}
